import {
  LevelTypeParams,
  TheoryTypes,
  type LevelType,
} from "./Education.types";

export function getSelectedLevelType({
  aiChatId,
  theoryId,
  questionIds,
  questionLoopIds,
  quizQuestionIds,
  diagnosticQuestionIds,
  wordlistIds,
  levelInfo,
}: LevelTypeParams): LevelType | null {
  if (theoryId) {
    return "theory";
  } else if (questionIds) {
    return "normal";
  } else if (questionLoopIds) {
    return "loops";
  } else if (quizQuestionIds) {
    return "quizOnWrongAnswers";
  } else if (diagnosticQuestionIds) {
    return "diagnosticTest";
  } else if (wordlistIds) {
    return "wordlists";
  } else if (aiChatId) {
    return "AIChat";
  } else if (levelInfo?.LevelType === "diagnosticTest") {
    return "diagnosticTest";
  } else {
    return null;
  }
}

export function levelTypeToTheoryType(levelType: LevelType): LevelType | null {
  switch (levelType) {
    case "questionsCaseStudy":
      return TheoryTypes.NORMAL;
    case "theory":
      return TheoryTypes.THEORY;
    case "normal":
      return TheoryTypes.NORMAL;
    case "loops":
    case "questionsLoop":
      return TheoryTypes.LOOPS;
    case "wordlists":
    case "wordlist":
      return TheoryTypes.WORDLISTS;
    case "quizOnWrongAnswers":
      return TheoryTypes.QUIZ;
    case "diagnosticTest":
      return TheoryTypes.DIAGNOSTIC_TEST;
    case "AIChat":
      return TheoryTypes.CHAT;
    case "AIRolePlay":
      return TheoryTypes.ROLEPLAY;
    case "branchingStory":
      return TheoryTypes.BRANCHINGSTORY;
    case "video":
      return TheoryTypes.VIDEO;
    case "questionsLinearAnswerMode":
      return TheoryTypes.NORMAL;
    default:
      return null;
  }
}
